import moment from 'moment'
import 'moment/locale/de'

import { defaultPost, createFormErrorHandler } from '@bikemap/js/utility'
import { notifications } from '@bikemap/js/services'
import { LANGUAGE } from '@bikemap/js/settings'

function initRounds(form) {
    const roundTrip = form.querySelector('input[name="round_trip"]')
    const trainingRounds = form.querySelector('.training-rounds')
    const toggleRoundTrip = () => {
        if (roundTrip.checked) {
            trainingRounds.classList.remove('hidden')
        } else {
            trainingRounds.classList.add('hidden')
        }
    }
    roundTrip.addEventListener('change', toggleRoundTrip)
    toggleRoundTrip()
}

function initDatePicker(form) {
    const datePicker = form.querySelector('#training-datetimepicker')
    const hidden = form.querySelector('#id_date')

    moment.locale(LANGUAGE === 'de' ? 'de' : 'en')

    // datetimepicker depends on jQuery
    $(datePicker)
        .datetimepicker({
            format: 'LL',
            icons: {
                date: 'i-calendar',
                up: 'i-chevron-up',
                down: 'i-chevron-down',
                previous: 'i-chevron-left',
                next: 'i-chevron-right',
                today: 'i-home',
                clear: 'i-delete',
                close: 'i-close',
            },
            locale: LANGUAGE,
            widgetPositioning: {
                vertical: 'top',
            },
        })
        .on('dp.change', date => {
            hidden.value = date.date ? date.date.format(moment.HTML5_FMT.DATE) : ''
        })
        .data('DateTimePicker').date(moment())
}

function initRouteSelect(routeSelect, form) {
    // typeahead depends on jQuery
    $(routeSelect).typeahead({
        minLength: 1,
        dynamic: true,
        blurOnTab: false,
        delay: 300,
        display: ['value', 'data.distance'],
        template: (query, item) => {
            let template = '<i class="i-map"></i><div class="tt-result-name">{{value}}</div>'
            if (item.data && item.data.distance) {
                template += '&nbsp;<div class="distance">{{data.distance}}</div>'
            }
            return template
        },
        filter: false,
        source: {
            routes: {
                ajax: {
                    url: routeSelect.dataset.autocompleteUrl,
                    data: {
                        q: '{{query}}',
                    },
                    path: 'suggestions',
                },
            },
        },
        callback: {
            onClick: (node, a, item) => {
                form.querySelector('#id_route').value = item.id
            },
        },
    })
}

export function initTrainingLogForm(form) {
    initRounds(form)
    initDatePicker(form)

    const routeSelect = form.querySelector('#selectroutes')
    if (routeSelect) initRouteSelect(routeSelect, form)
}

export function submitTrainingLogEntry(form) {
    return defaultPost(form.action, new FormData(form))
        .then(createFormErrorHandler(form))
        .then(res => {
            const { title, content } = res.callback_params.finished
            if (res.success) {
                notifications.show({
                    title,
                    icon: 'i-check',
                    message: content,
                    type: 'success',
                })
                form.reset()
                $(form)
                    .find('.date')
                    .data('DateTimePicker')
                    .date(moment())
            }
            return res
        })
}
